var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: { "white-space": "nowrap" },
      attrs: { id: "audio-player-root" },
    },
    [
      _c("div", [
        _c(
          "audio",
          {
            ref: "player",
            staticStyle: { display: "none" },
            attrs: { id: _vm.playerid },
          },
          [_c("source", { attrs: { src: _vm.url, type: "audio/mpeg" } })]
        ),
      ]),
      _c("span", { staticClass: "pr-2" }, [_vm._v(_vm._s(_vm.label))]),
      _vm.isPlaying || _vm.percentProgress() > 0
        ? _c(
            "v-progress-circular",
            {
              attrs: {
                value: _vm.percentProgress(),
                color: _vm.isPlaying ? "lime" : "grey",
              },
            },
            [
              [
                _c(
                  "v-btn",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isPlaying,
                        expression: "!isPlaying",
                      },
                    ],
                    attrs: { icon: "" },
                    on: {
                      click: function ($event) {
                        return _vm.toggleAudio()
                      },
                    },
                  },
                  [_c("v-icon", [_vm._v("mdi-play-circle")])],
                  1
                ),
                _c(
                  "v-btn",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isPlaying,
                        expression: "isPlaying",
                      },
                    ],
                    attrs: { icon: "" },
                    on: {
                      click: function ($event) {
                        return _vm.toggleAudio()
                      },
                    },
                  },
                  [_c("v-icon", [_vm._v("mdi-pause-circle")])],
                  1
                ),
              ],
            ],
            2
          )
        : _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function ($event) {
                  return _vm.toggleAudio()
                },
              },
            },
            [_c("v-icon", [_vm._v("mdi-play-circle")])],
            1
          ),
      _vm.expanded
        ? _c(
            "span",
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.stopAudio()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-stop-circle")])],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "text-sm mx-2",
          staticStyle: { color: "#94bcec" },
          domProps: { innerHTML: _vm._s(_vm.elapsed_time) },
        },
        [_vm._v(" 0:00 ")]
      ),
      _c(
        "span",
        {
          staticClass: "text-sm",
          staticStyle: { color: "#94bcec" },
          domProps: { innerHTML: _vm._s(_vm.totalTime()) },
        },
        [_vm._v(" 0:00 ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }